module.exports = __webpack_public_path__ + "img/overlay-payment-method.f4f36e2e.svg";